"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.documentView", ["nucont.shared"]);
require("./document-view.routes");
